// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__27Rk7","signatureButtonsRight":"ModalSign_signatureButtonsRight__3wE8g"};